﻿window.addEventListener('load', function () {
    let preloader = document.getElementById('preloader');
    if (preloader) {
        setInterval(function () {
            preloader.classList.remove('visible');
        }, 750);
    }
});